import React from "react";
import PropTypes from "prop-types";

import { Button, Container, Header, Segment } from "semantic-ui-react";

function SupportRequestConfirmation({ onClose }) {
  return (
    <Container>
      <Segment basic textAlign="center">
        <Header as="h2">User Deactivation Submitted</Header>

        <div
          style={{ lineHeight: "1.5" }}
          data-test="support-request-confirmation-text"
        >
          Your request will be processed soon. We will inform you once the user
          has been successfully deactivated.
        </div>

        <div style={{ marginTop: "2em" }}>
          <Button primary content="Close" onClick={onClose} />
        </div>
      </Segment>
    </Container>
  );
}

SupportRequestConfirmation.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default SupportRequestConfirmation;
